<template>
  <el-dialog
    width="600px"
    :visible="visible"
    :close-on-click-modal="false"
    title="附件上传"
    @close="close"
    @open="open"
    append-to-body
  >
    <el-upload
      class="upload-demo"
      drag
      ref="new_upload"
      :action="action"
      :file-list="fileList"
      multiple
      :show-file-list="false"
      :auto-upload="true"
      :before-upload="beforeUpload"
      :on-progress="handleProgress"
      :accept="'.png,.jpg,.jpeg,.bmp,.pdf'"
      :on-success="onSuccess"
      :on-error="onError"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">点击或将文件拖拽到这里上传</div>
      <div class="el-upload__tip">
        支持格式:"png"，"jpg"，"jpeg"，"bmp"，"pdf"
        单个文件最大5M，最大支持一次性批量上传30M
      </div>
    </el-upload>
    <div>
      <div v-for="(file, index) in fileList" :key="file.uid" class="list_box">
        <div class="file_item">
          <div class="name_progress">
            <img
              src="/static/img/fileIcon.png"
              alt=""
              width="22px"
              height="22px"
            />
            <div>
              <div
                class="file-name"
                :style="{
                  color:
                    file.status == 'success'
                      ? '#269D7B'
                      : file.status == 'error' || file.status == 'fail'
                      ? '#FF6010'
                      : '',
                }"
              >
                {{ file.name }}
                <span
                  style="margin-left: 16px; color: #ff6010"
                  v-if="file.status == 'error' || file.status == 'fail'"
                >
                  {{file.errMsg}}
                </span>
              </div>
              <!-- 进度条 -->
              <el-progress
                v-if="file.status === 'uploading'"
                :percentage="file.progress"
                :stroke-width="4"
                style="width: 408px"
                :show-text="false"
              ></el-progress>
            </div>
          </div>
          <div class="btns">
            <el-button type="text" @click="onPreview(file, index)">
              <img
                src="/static/img/file_view.png"
                alt=""
                width="16px"
                height="16px"
              />
            </el-button>
            <el-button type="text" @click="handleReplace(file)">
              <img
                src="/static/img/file_replace.png"
                alt=""
                width="16px"
                height="16px"
              />
            </el-button>
            <el-button type="text" @click="onRemove(file)">
              <img
                src="/static/img/file_del.png"
                alt=""
                width="16px"
                height="16px"
              />
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <previewPicture ref="previewPicture" :images="images" />
  </el-dialog>
</template>

<script>
import previewPicture from "@/components/previewPicture";
import { imgShow,uploadUrlTwo } from "@/assets/js/apiConfig.js";
export default {
  components: {
    previewPicture,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      promptTimeout:null,
      oversizedFiles:[],
      oldFile: null,
      imgShow,
      images: [],
      fileList: [],
      action: uploadUrlTwo,
      // action:'http://192.168.1.250:8070/fileManager/uploadFilesTwo'
    };
  },
  mounted() {
   
  },
  beforeDestroy() {
   
  },
  methods: {
    open(){
       // 监听全局粘贴事件（即使焦点不在页面内）
      document.addEventListener("paste", this.handlePaste);
    },
    onError(err,file,fileList){
      const robustMatch = String(err).match(/<b>消息<\/b>[\s\S]*?<p><b>描述<\/b>/);
        if (robustMatch) {
          // 提取匹配内容并清理标签
          const message = robustMatch[0]
            .replace(/<\/?[^>]+>/g, "") // 删除所有HTML标签
            .replace(/(消息|描述)/g, "") // 清理残留字段
            .trim();
            console.log(this.fileList,file)
            this.fileList.forEach(e=>{
                if(e.uid == file.uid){
                  this.$set(e,'errMsg',message?message:'文件上传失败,请重新上传')
                }
            })
        }
    },
    handleReplace(file) {
      this.oldFile = file;
      console.log(file)
      this.$refs.new_upload.$el.querySelector("input[type=file]").click();
    },
    onPreview(file, index) {
      // console.log(this.fileList)
      this.images = this.fileList.map(x=>{
        if(x.response){
          return `${this.imgShow}${x.response.data[0].imgUrl}`
        }
      })
      console.log(this.images)
      // this.images = this.fileList [`${this.imgShow}${file.response.data[0].imgUrl}`];
      this.$refs.previewPicture.show(index);
    },
    handleProgress(event, file) {
      console.log(file)
      const target = this.fileList.find((f) => f.uid === file.uid);
      if (target) target.progress = Math.floor(event.percent);
    },
    onRemove(file, fileList) {
      this.fileList = this.fileList.filter((f) => f.uid !== file.uid);
      // this.fileList = fileList;
      this.$emit("sendData", {},this.fileList, "remove",file);
    },
    clearFile() {
      this.fileList = [];
      console.log(this.fileList)
    },
    // 处理粘贴事件
    async handlePaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      if (!clipboardData) return;

      const items = clipboardData.items;
      if (!items) return;

      const files = [];
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file") {
          // 处理从外部复制的文件（如本地文件）
          const file = item.getAsFile();
          if (file) files.push(file);
        } else if (item.type.startsWith("image/")) {
          // 处理截图等图片数据
          const blob = item.getAsFile();
          const file = new File([blob], `pasted-image-${Date.now()}.png`, {
            type: "image/png",
          });
          files.push(file);
        }
      }
      if (files.length > 0) {
        files.forEach((file) => {
          // event.preventDefault();  // 阻止默认粘贴行为
          console.log(this.$refs.new_upload)
          this.$refs.new_upload.handleStart(file); // 调用 el-upload 内部方法
          this.$refs.new_upload.submit();
        });
      }
    },
    editFileList(item) {
      this.fileList = this.fileList.filter(
        (x) => x.response.data[0].imgUrl != item.imgUrl
      );
    },
    onSuccess(response, file, fileList) {
      this.fileList = fileList;
      // console.log(response,fileList)
      this.$emit("sendData", response,fileList);
    },
    beforeUpload(file) {
      if (file.size > 5 * 1024 * 1024) {
        // this.$message.error("单个文件的大小不能超过5MB");
        this.oversizedFiles.push(file.name)
         // 如果还没有定时器，创建一个（防重复）
        if (!this.promptTimeout) { 
          this.promptTimeout = setTimeout(() => {
            this.$message.error(`文件大小不能超过5MB: ${this.oversizedFiles.join(', ')}`); // 🟢 统一提示
            this.oversizedFiles = []; // 清空缓存
            this.promptTimeout = null; // 重置定时器
          }, 0); // ⏳ 关键点：延迟 0ms
        }
    
        return false;
      }
      const type = file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase();
      if (["png", "jpg", "jpeg", "bmp", "pdf"].indexOf(type) > -1) {
        if (this.oldFile) {
          // 找到被替换文件的索引
          const index = this.fileList.findIndex(
            (f) => f.uid === this.oldFile.uid
          );

          // 替换文件项（保留原UID）
          // this.fileList.splice(index,1)
          this.fileList.splice(index, 1, {
            ...this.oldFile,
            name: file.name,
            progress: 0,
            status: "uploading",
            raw: file,
            uid:file.uid,
          });

          this.oldFile = null;
          return true
        } else {
          this.fileList.push({
            uid: file.uid,
            name: file.name,
            progress: 0,
            status: "uploading", // 状态：uploading/done/error
            raw: file, // 保留原始文件对象
          });
          return true;
        }
      } else {
        this.$message.error("仅支持png,jpg,jpeg,bmp,pdf格式的文件");
        return false;
      }
    },
    close() {
      console.log(11);
      document.removeEventListener("paste", this.handlePaste);
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="less" scoped>
.list_box {
  // display: flex;
  // flex-direction:column;
  // row-gap: 20px;
}
/deep/ .el-button--text {
  margin: 0 !important;
  padding: 0 !important;
}
.file_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  .name_progress {
    display: flex;
    align-items: center;
    column-gap: 20px;
    // width: 408px;
  }
  .file-name {
    width: 408px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .btns {
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
}
/deep/ .el-dialog__title {
  font-weight: bold !important;
}
/deep/ .el-dialog__close {
  font-weight: bold !important;
  color: #333333 !important;
}
/deep/ .el-upload-dragger {
  color: #269d7b !important;
  width: 100% !important;
  height: 200px !important;
  background: rgba(251, 251, 251, 1) !important;
  border-radius: 2px !important;
}
/deep/ .el-upload__tip {
  padding: 0 108px;
  box-sizing: border-box;
  color: #999999;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/uploadVoucherFile.vue